var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleInfoSolid1ActiveAdditionalInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22C15.1522 22 17.6957 20.9464 19.5711 19.0711C21.4464 17.1957 22.5 14.6522 22.5 12C22.5 9.34784 21.4464 6.8043 19.5711 4.92893C17.6957 3.05357 15.1522 2 12.5 2C9.84784 2 7.3043 3.05357 5.42893 4.92893C3.55357 6.8043 2.5 9.34784 2.5 12C2.5 14.6522 3.55357 17.1957 5.42893 19.0711C7.3043 20.9464 9.84784 22 12.5 22ZM10.9375 15.125H11.875V12.625H10.9375C10.418 12.625 10 12.207 10 11.6875C10 11.168 10.418 10.75 10.9375 10.75H12.8125C13.332 10.75 13.75 11.168 13.75 11.6875V15.125H14.0625C14.582 15.125 15 15.543 15 16.0625C15 16.582 14.582 17 14.0625 17H10.9375C10.418 17 10 16.582 10 16.0625C10 15.543 10.418 15.125 10.9375 15.125ZM12.5 7C12.8315 7 13.1495 7.1317 13.3839 7.36612C13.6183 7.60054 13.75 7.91848 13.75 8.25C13.75 8.58152 13.6183 8.89946 13.3839 9.13388C13.1495 9.3683 12.8315 9.5 12.5 9.5C12.1685 9.5 11.8505 9.3683 11.6161 9.13388C11.3817 8.89946 11.25 8.58152 11.25 8.25C11.25 7.91848 11.3817 7.60054 11.6161 7.36612C11.8505 7.1317 12.1685 7 12.5 7Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInfoSolid1ActiveAdditionalInfo);
export default __webpack_public_path__ + "static/media/circle-info-solid 1Active-AdditionalInfo.5a4136b0f4ace4e182ba3d8262fe1978.svg";
export { ForwardRef as ReactComponent };